import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { CommonResponse } from '../shared/models/common-response';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CONFIG } from '../../environments/config';
import { SessionService } from './session.service';
import { EncryptionUtil } from './encryption-util';
import { ContextService } from './context.service';
import * as crypto from 'crypto-js';
import { environment } from '../../environments/environment';
import { SignalService } from './signals/signal.service';
import { AccountFormatService } from './account-format.service';

@Injectable({
  providedIn: 'root'
})
export class MsCallService {
  servicesUrl = '';
  privateServicesUrl: string;
  isCallCenter: boolean;

  constructor(
    private http: HttpClient,
    protected sessionService: SessionService,
    private encryptService: EncryptionUtil,
    private signalService: SignalService,
    protected contextService: ContextService,
    protected accountFormatService: AccountFormatService
  ) {
    this.isCallCenter = this.sessionService.isCallCenter === 'true' ? true : false;
  }

  public msCall(body: any, path: string, ignoreSessionHeaders = false, isPrivate = false): Observable<CommonResponse> {
    console.log('ignoreSessionHeaders', ignoreSessionHeaders);
    const sessionHeaders: any = this.setSessionHeaders(ignoreSessionHeaders);

    console.log('SESSION HEADERS ', sessionHeaders);
    const formatHeaders = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'channel': this.contextService.getChannelName(),
      'country': 'PE',
      'commerce': 'Banco',
      'product-name': this.accountFormatService.getProductName(),
      'x-flow-session-id': this.getFlowSessionId(),
      'x-flow-transaction-id': this.getNewId(),
      'x-session-id': this.getSessionId(),
      'iscallcenter': String(this.isCallCenter),
      ...sessionHeaders
    };
    console.log('FORMAT HEADERS', formatHeaders);

    const httpMicroServiceCall = {
      headers: new HttpHeaders(formatHeaders)
    };
    const serviceUrl = isPrivate && !this.isCallCenter  ? this.privateServicesUrl + path : this.servicesUrl + path;
    this.signalService.lastPathCalled.set(path);
    return this.http.post<CommonResponse>(serviceUrl, body, httpMicroServiceCall)
      .pipe(catchError(this.handleError.bind(this)));
  }

  private setSessionHeaders(ignoreSessionHeaders: boolean) {
    const platform = (ignoreSessionHeaders || !this.contextService.isMobile()) ?
      this.contextService.getMode() :
      this.sessionService.mobilePlatform;

    if (ignoreSessionHeaders) {
      return { platform };
    }

    let sessionHeaders = this.sessionService.getRequestHeaders();
    if (this.contextService.isWC()) {
      sessionHeaders = this.EncryptHeaders(sessionHeaders);
    }

    return { platform, ...sessionHeaders };
  }

  public EncryptHeaders(sessHeaders: any) {
    for (const prop in sessHeaders) {
      if (!CONFIG.headerExceptions.includes(prop)) {
        sessHeaders[prop] = this.encryptService.encryptMessage(`${sessHeaders[prop]}`, environment.pubKey);
      }
    }
    return sessHeaders;
  }

  getFlowSessionId(): string {
    let flowSessionId: string;
    try {
      const prevflowSessionId = localStorage.getItem('flowSessionId');
      flowSessionId = prevflowSessionId ? prevflowSessionId : this.getNewId();
      if (!prevflowSessionId) {
        localStorage.setItem('getFlowSessionId flowSessionId', flowSessionId);
      }
    } catch (error) {
      flowSessionId = this.getNewId();
    }
    return flowSessionId;
  }

  getSessionId(): string | null {
    let sessionid;
    try {
      sessionid = this.contextService.isMobile() ? sessionStorage.getItem('sessionId') : localStorage.getItem('sessionId');
    } catch (error) {
      sessionid = sessionStorage.getItem('sessionId');
    }
    return sessionid;
  }

  getNewId(): string {
    const md5 = (textToDigest) => crypto.MD5(textToDigest).toString();
    const rnd = (length) => crypto.lib.WordArray.random(length).toString();
    return md5(rnd(10));
  }

  public handleError(error: HttpErrorResponse): Observable<any> {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      if (this.signalService.lastPathCalled() === environment.SERVICES.PASSWORD_CREATE.URI) {
        this.signalService.createPasswordError.set(true);
      }
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
    return throwError(error.status);
  }
}
